export const messages = {
  en: {
    feeReceiptReport: {
      title: 'Receipt Report',
      tabIssued: 'Issued Receipts',
      tabVoided: 'Voided Receipts',
      startTime: 'Start Date',
      endTime: 'End Date',
      totalCount: 'Total Count',
      totalAmount: 'Total Amount',
      issuedReport: 'Issued Receipt Report',
      voidedReport: 'Voided Receipt Report',
      receiptCode: 'Receipt Code',
      objType: 'Type',
      feeName: 'Fee Item',
      roomName: 'Room/Carport',
      payObjName: 'Payer',
      amount: 'Amount(¥)',
      receivableAmount: 'Receivable(¥)',
      payTime: 'Payment Time',
      houseFee: 'House',
      parkingFee: 'Parking',
      fetchError: 'Failed to fetch report data',
      exportTip: 'Export not yet configured',
      noDataExport: 'No data to export',
      exportSuccess: 'Exporting, please go to Download Center to download',
      exportError: 'Export failed'
    }
  },
  zh: {
    feeReceiptReport: {
      title: '收据报表',
      tabIssued: '已开收据',
      tabVoided: '作废单据',
      startTime: '开始日期',
      endTime: '结束日期',
      totalCount: '总笔数',
      totalAmount: '总金额',
      issuedReport: '已开收据报表',
      voidedReport: '作废单据报表',
      receiptCode: '收据编号',
      objType: '类型',
      feeName: '费用项',
      roomName: '房屋/车位',
      payObjName: '付款人',
      amount: '实收金额(元)',
      receivableAmount: '应收金额(元)',
      payTime: '缴费时间',
      houseFee: '房屋',
      parkingFee: '车位',
      fetchError: '获取报表数据失败',
      exportTip: '导出功能待配置',
      noDataExport: '没有数据可导出',
      exportSuccess: '正在导出，请到下载中心下载',
      exportError: '导出失败'
    }
  }
}
